import { Routes, Route } from "react-router-dom";
import React, { lazy, Suspense } from "react";
import PageLoading from "../components/loading/page";
import Layout from "../components/layout";
import AuthRoute from "./auth_route";

const DashboardPage = lazy(() => import("../pages/dashboard"));
const UserPage = lazy(() => import("../pages/user"));
const RolePage = lazy(() => import("../pages/role"));
const RoleDetailPage = lazy(() => import("../pages/role/detail"));
const LinkPage = lazy(() => import("../pages/link"));
const LinkAnalyticsPage = lazy(() => import("../pages/link/analytics"));
const AnalyticsDetailPage = lazy(() => import("../pages/link/analytics/detail"));
const ProfilePage = lazy(() => import("../pages/profile"));
const LoginHistoryPage = lazy(() => import("../pages/login_history"));
const LinkHistoryPage = lazy(() => import("../pages/link_history"));
const LogPage = lazy(() => import("../pages/log"));
const WhitelistIPPage = lazy(() => import("../pages/whitelist_ip"));

const BlockedPage = lazy(() => import("../pages/blocked"));
const LoginPage = lazy(() => import("../pages/login"));
const Verify2FAPage = lazy(() => import("../pages/verify2fa"));
const ErrorPage = lazy(() => import("../pages/error"));

export default function Router() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/">
            <Route index={true} element={
              <AuthRoute>
                <DashboardPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/users">
            <Route index={true} element={
              <AuthRoute>
                <UserPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/roles">
            <Route index={true} element={
              <AuthRoute>
                <RolePage />
              </AuthRoute>
            } />
            <Route path={':roleId'} element={
              <AuthRoute>
                <RoleDetailPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/links">
            <Route index={true} element={
              <AuthRoute>
                <LinkPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/analytics">
            <Route index={true} element={
              <AuthRoute>
                <LinkAnalyticsPage />
              </AuthRoute>
            } />
            <Route path={'detail'} element={
              <AuthRoute>
                <AnalyticsDetailPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/profile">
            <Route index={true} element={
              <AuthRoute>
                <ProfilePage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/login-history">
            <Route index={true} element={
              <AuthRoute>
                <LoginHistoryPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/link-history">
            <Route index={true} element={
              <AuthRoute>
                <LinkHistoryPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/logs">
            <Route index={true} element={
              <AuthRoute>
                <LogPage />
              </AuthRoute>
            } />
          </Route>

          <Route path="/whitelist-ips">
            <Route index={true} element={
              <AuthRoute>
                <WhitelistIPPage />
              </AuthRoute>
            } />
          </Route>
        </Route>

        <Route path="blocked" element={<BlockedPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="verify2fa" element={<Verify2FAPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Suspense>
  );
}